/**
 * @namespace toolkit.constants
 */
 
 /**
 * @class toolkit.constants.TypeConsts
 * @classdesc The type constants.
 */
export class TypeConsts {

    /**
     * The empty guid constant.
     * @member {string} toolkit.constants.TypeConsts#emptyGuid
     */   
    public static emptyGuid: string = '00000000-0000-0000-0000-000000000000';
}


// WEBPACK FOOTER //
// ./src/constants/typeConsts.ts